import { DatePipe, formatDate } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MatDatepicker, MatPaginator, MatSort, MatTableDataSource, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from 'app/contabilidad/nuevo-tipo-cambio/nuevo-tipo-cambio.component';
import { FiltrosConcar } from 'app/models/FiltrosConcar.model';
import { ReportesService } from 'app/services/reportes/reportes.service';
import moment, { Moment } from 'moment';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-rep-concar',
  templateUrl: './rep-concar.component.html',
  styleUrls: ['./rep-concar.component.scss'],
  providers: [DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class RepConcarComponent implements OnInit {

  date = new FormControl(moment());
  displayedColumns = ['subdiario', 'numero_comprobante', 'fecha_comprobante', 'codigo_moneda', 'glosa_principal', 'tipo_cambio', 'tipo_conversion', 'flag_conversion_moneda', 'fecha_tipo_cambio', 'cuenta_contable', 'codigo_anexo', 'codigo_centro_costo', 'debe_haber', 'importe_original', 'importe_dolares', 'importe_soles', 'tipo_documento', 'numero_documento', 'fecha_documento', 'fecha_vencimiento', 'codigo_area', 'glosa_detalle', 'codigo_anexo_auxiliar', 'medio_pago', 'tipo_documento_referencia', 'numero_documento_referencia', 'fecha_documento_referencia', 'nro_maq_registradora_tipo_doc_ref', 'base_imponible_documento_referencia', 'igv_documento_provision', 'tipo_referencia_estado_mq', 'numero_serie_caja_registradora', 'fecha_operacion', 'tipo_tasa', 'tasa_detraccion_percepcion', 'importe_base_detraccion_percepcion_dolares', 'importe_base_detraccion_percepcion_soles', 'tipo_cambio_para_f', 'importe_igv_sin_derecho_credito_fiscal'];
  pageSizeOptions = [15, 20, 30, 50, 100, 200,1000];
  dataSource: any;
  dataEnviar: any = []
  dataLista: any = []
  loading: boolean;
  formReporteConcar: FormGroup;
  rangeFechas: FormGroup;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('TABLE', { static: true }) table: ElementRef;

  constructor(
    private reporteService: ReportesService,
    private datePipe: DatePipe,
    private formBuilder: FormBuilder
  ) {
    const today = new Date();
    this.rangeFechas = this.formBuilder.group({
      fechaDesde: [today, Validators.required],
      fechaHasta: [today, Validators.required],
    });
    this.formReporteConcar = this.formBuilder.group({
      rangeFechas: this.rangeFechas
    });
  }

  ngOnInit() {
    this.obtenerLista();
  }

  tipoMoneda(event) {
    if (event == '') {
      this.formReporteConcar.controls['Moneda'].setValue(0);
    } else {
      this.formReporteConcar.controls['Moneda'].setValue(event);
    }
  }

  chosenYearHandler(normalizedYear: Moment) {
    const ctrlValue = this.date.value;
    ctrlValue.year(normalizedYear.year());
    this.date.setValue(ctrlValue);
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const ctrlValue = this.date.value;
    ctrlValue.month(normalizedMonth.month());
    ctrlValue.year(normalizedMonth.year());
    this.date.setValue(ctrlValue);
    datepicker.close();
  }

  ExportTOExcel() {

     const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.dataLista);
   // const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    // let fecha = new Date();
    let fecha = this.datePipe.transform(this.date.value._d, 'yyyyMMdd')
    XLSX.writeFile(wb, 'Reporte_Concar' + fecha + '.xlsx');
  }

  obtenerLista() {
    let rawValue = this.formReporteConcar.getRawValue();
    let filtroReporteConcar: FiltrosConcar = {
      fechaDesde: this.datePipe.transform(
        rawValue.rangeFechas.fechaDesde,
        "yyyy-MM-dd"
      ),
      fechaHasta: this.datePipe.transform(
        rawValue.rangeFechas.fechaHasta,
        "yyyy-MM-dd"
      )
    };
    this.loading = true;
    this.reporteService.obtenerReporteConcar(filtroReporteConcar).subscribe(
      res => {
        this.dataLista = res.body;
        this.dataSource = new MatTableDataSource(this.dataLista);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.loading = false;
      }, err => {
        Swal.fire({
          title: "¡Algo salió mal!",
          text: err.error['error'],
          type: "warning",
          allowOutsideClick: true,
          heightAuto: false
        });
        this.loading = false;
      }
    )
  }

}
